// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientEnrollmentControllerEnrollmentWithEmailSignatureTemplateRequestResponse {
    static getAttributeTypeMap() {
        return PatientEnrollmentControllerEnrollmentWithEmailSignatureTemplateRequestResponse.attributeTypeMap;
    }
}
PatientEnrollmentControllerEnrollmentWithEmailSignatureTemplateRequestResponse.discriminator = undefined;
PatientEnrollmentControllerEnrollmentWithEmailSignatureTemplateRequestResponse.additionalProperties = false;
PatientEnrollmentControllerEnrollmentWithEmailSignatureTemplateRequestResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentV2ProcessingResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=patientEnrollmentControllerEnrollmentWithEmailSignatureTemplateRequestResponse.js.map